export const DAPP_UI_VERSION = '1.4.1';
